import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import useAuth from "../../../hooks/useAuth";

const BlogerRoute = ({ children, ...rest }) => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [logedInUser, setLogedInUser] = useState(null);
  useEffect(() => {
    if (user?.email) {
      setIsLoading(true);
      fetch(`https://api.thepsycure.com/users/${user?.email}`)
        .then((res) => res.json())
        .then((data) => {
          setLogedInUser(data);
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  const location = useLocation();

  if (isLoading || (logedInUser === null && user?.email)) {
    return (
      <div style={{ paddingTop: "15%", textAlign: "center" }}>
        <CircularProgress />
      </div>
    );
  } else {
    if (logedInUser?.role === "patient") {
      return <Navigate to="/" state={{ from: location }} />;
    }
    if (logedInUser?.role === "admin") {
      return <Navigate to="/" state={{ from: location }} />;
    }
    if (logedInUser?.role === "psychologist") {
      return <Navigate to="/" state={{ from: location }} />;
    }

    if (!isLoading && !logedInUser?.role) {
      return <Navigate to="/bloger-signin" state={{ from: location }} />;
    } else if (logedInUser?.email && logedInUser?.role === "bloger") {
      return children;
    }
  }
};

export default BlogerRoute;
